module.exports = __webpack_public_path__ + "img/android.71f907a8.svg";